import * as TYPES from './types';
export const validateUtils = {
  notEmpty: ({ formValues, formFields, customMessage = {} }: TYPES.NotEmptyProps) => {
    interface Error {
      [key: string]: string;
    }

    return formFields.reduce((acc: Error, { name, label }) => {
      if (!formValues[name]) {
        const campo = label ? label.toLowerCase() : '';
        acc[name] = customMessage[name] || `O campo ${campo} não pode ser vazio.`;
      }
      return acc;
    }, {});
  },
};
